<template>
  <div v-show="show" class="element-top">
    <div>
      <v-toolbar
        elevation="1"
        class="call-toolbar"
        :class="{ show: show }"
        :height="
          !$vuetify.breakpoint.smAndDown && $props.video ? '67px' : '50px'
        "
      >
        <v-toolbar-title class="call-title"
          >{{ $t("calling") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn small plain>
            {{ $t("duration") }}<chronometer :isCall="true" v-if="show"></chronometer>
          </v-btn>
          <v-tooltip bottom v-if="isOnVideoCall">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="switchShowVideo">
                <v-icon
                  v-text="showTextInput ? 'mdi-eye' : 'mdi-note-multiple'"
                ></v-icon>
              </v-btn>
            </template>
            <span>{{ $t("write") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="mutebutton" class="ma-0">
                <v-icon
                  class="mic-mute red--text darken-1"
                  v-html="mute ? 'mdi-microphone-off' : 'mdi-microphone'"
                  color="error"
                ></v-icon>
              </v-btn>
            </template>
            <span>{{ mute ? $t("unmute") : $t("mute") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="hangup" class="hangup-button ma-0">
                <v-icon>mdi-phone-hangup</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("hangup") }}</span>
          </v-tooltip>
        </v-toolbar-items>
      </v-toolbar>
    </div>

    <div
      :class="
        $props.video
          ? $vuetify.breakpoint.smAndDown
            ? 'video-container'
            : 'video-container-fs'
          : null
      "
    >
      <video
        v-show="video"
        :class="{ show: showVideo && !isOnHold }"
        id="agentsCamera"
        autoplay
        playsinline
        ref="agentself"
        :style="[
          {
            'max-height': $vuetify.breakpoint.smAndDown
              ? '188px !important'
              : '70vh',
          },
        ]"
      ></video>
      <div v-show="video && isOnHold" class="hold-overlay">
        <v-icon large class="hold-icon">mdi-phone-paused</v-icon>
        <span>{{ $t("callonhold") }}</span>
      </div>
      <div
        :class="
          $vuetify.breakpoint.smAndDown
            ? 'myCameraContainer'
            : 'myCameraContainer-fs'
        "
      >
        <video
          v-show="video"
          id="myCamera"
          autoplay
          playsinline
          muted
          ref="myself"
        ></video>
      </div>
    </div>
  </div>
</template>

<script>
import WebRTCPhone from "@/assets/WebRTCPhone";
import Chronometer from "./chronometer.vue";
export default {
  props: { show: Boolean, video: Boolean },
  name: "call",
  components: {
    Chronometer,
  },

  data() {
    return {
      phone: null,
      mute: false,
      showVideo: true,
      isOnVideoCall: false,
      isOnHold: false,
    };
  },

  computed: {
    storeCallHold() {
      const campaignName = this.$route.query.campaign;
      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );
      return index >= 0 ? this.$store.state[index].callHold : false;
    },
  },

  watch: {
    show() {
      if (this.show) {
        this.initTelephony();
      }
    },
    storeCallHold(val) {
      this.isOnHold = val;
    },
  },

  created() {
    if (this.video) {
      this.showVideo = true;
    }
  },

  mounted() {
    this.initTelephony();
  },

  methods: {
    async initTelephony() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      if (this.show) {
        let agentself = this.$refs.agentself;
        let myself = this.$refs.myself;

        //instancio el telefono de la clase

        let campaign = this.$store.state[index].configuration.campaign;
        let guid = this.$store.state[index].interaction.guid;
        let turnConf = this.$store.state[index].turnConf;
        let telephonyServer = this.$store.state[index].telephonyServer;

        this.phone = new WebRTCPhone(
          telephonyServer, campaign, guid, turnConf,
          this.hangup,
        );

        this.$emit("phone", this.phone);

        this.phone.setVideoElements(myself, agentself, this.$store);

        this.phone.startUA();
        this.phone.makeCall(
          this.$store.state[index].interaction.telAgent,
          this.video
        );
      }
    },

    hangup() {
      this.$emit("hangupEv");
      if (this.phone) {
        this.$store.commit("setIsInCall", false);
        this.$store.commit("setCallHold", false);
        this.phone.hangUp();
      } else {
        window.close();
      }
    },

    mutebutton() {
      this.mute = !this.mute;
      if (this.mute) this.phone.mute();
      else this.phone.unmute();
    },

    switchShowVideo() {
      this.showVideo = !this.showVideo;
      this.showTextInput = !this.showTextInput;
      this.$emit("hideTextAreaEv");
    },
  },
};
</script>

<style scoped>
video {
  object-fit: cover;
  max-height: 300px;
}

.mic-mute {
  color: #fff !important;
  font-size: 27px;
}

.iconcontainer {
  padding-top: 30px;
}

.iconcontainer i {
  color: #4caf50;
  font-size: 200px;
  text-align: center;
  width: 100%;
}

.hidevideo {
  display: none;
}

#myCamera {
  z-index: 6;
  width: 98px;
  border-radius: 2px;
  box-shadow: 0px 0px 10px 1px #0000007d;
}

.myCameraContainer {
  position: absolute;
  bottom: 8px;
  left: 10px;
  z-index: 5;
  pointer-events: none;
}
.myCameraContainer-fs {
  position: absolute;
  top: 70px;
  left: 3px;
  z-index: 5;
  pointer-events: none;
}

#agentsCamera {
  width: 100%;
  display: none;
  z-index: -1;
  background-color: black;
  /* box-shadow: 0px 0px 5px 0px #000000de; */
  transition: all 0.3s ease-out;
}

#agentsCamera.show {
  top: 147px;
  display: block;
  z-index: 5;
  transition: all 0.3s ease-out;
}

.callcontainer {
  height: 100%;
  width: 100%;
}

.call-toolbar {
  opacity: 0;
  width: 100%;
  height: 39px;
  z-index: 1;
  transition: all 0.2s ease-out;
}
.element-top {
  top: 67px;
  width: 100%;
  z-index: 100000;
}
.call-toolbar.show {
  opacity: 1;
  z-index: 5;
  transition: all 0.2s ease-out;
}

.call-title {
  text-transform: uppercase;
  font-size: 16px;
  margin-top: 3px;
}

.call-toolbar .v-toolbar__content .v-toolbar__items {
  right: 20px;
  top: 2px;
}
.video-container {
  height: 188px;
  position: relative;
}

.video-container-fs {
  height: calc(100svh - 67px);
  overflow: auto;
  display: flex;
  align-items: center;
  position: relative;
}

.hold-overlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background-color: #1a1a2e;
  color: #ffffff;
  font-size: 18px;
}

.hold-icon {
  color: #ffffff !important;
}
</style>
